// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"bc6d2573","39":"e2d3ae45","53":"8b4388ac","464":"7f12a1fb","520":"b80f2e9d","628":"f0944924","685":"ce29df93","940":"e141c240"}[chunkId] + ".chunk.css";
};